import { render } from "./role-modal.vue?vue&type=template&id=95870b9e"
import script from "./role-modal.vue?vue&type=script&lang=ts"
export * from "./role-modal.vue?vue&type=script&lang=ts"
script.render = render

export default script